"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    SpringBigThemeProvider: ()=>SpringBigThemeProvider,
    useSpringBigTheme: ()=>useSpringBigTheme
});
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _merge = /*#__PURE__*/ _interopRequireDefault(require("lodash/merge"));
const _nativeBase = require("native-base");
const _ = require("..");
const _defaults = require("./defaults");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const Context = /*#__PURE__*/ _react.default.createContext({
    colorMode: 'light'
});
const SpringBigThemeProvider = ({ children , themeConfig  })=>{
    const { value: colorMode , setValue: setColorMode  } = (0, _.useStorageValue)('colorMode');
    // eslint-disable-next-line require-await
    const getColorMode = (0, _react.useCallback)(async (init)=>{
        if (colorMode) {
            return colorMode;
        }
        if (init) {
            return init;
        }
        if (colorMode === null) {
            setColorMode('light');
        }
        return 'light';
    }, [
        colorMode
    ]);
    const colorModeManager = {
        get: getColorMode,
        set: setColorMode
    };
    const inset = {
        frame: {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        },
        insets: {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
        }
    };
    return /*#__PURE__*/ _react.default.createElement(Context.Provider, {
        value: {
            colorMode
        }
    }, /*#__PURE__*/ _react.default.createElement(_nativeBase.NativeBaseProvider, {
        initialWindowMetrics: inset,
        colorModeManager: colorModeManager,
        theme: (0, _nativeBase.extendTheme)((0, _merge.default)({}, _defaults.themeConfig, themeConfig))
    }, children));
};
const useSpringBigTheme = ()=>(0, _react.useContext)(Context);
